import React, { useEffect } from 'react'
import useExecScripts from '../Component/useExecScripts'

function About() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="1007" className="elementor elementor-1007">
										<div className="elementor-element elementor-element-0e1e6b2 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="0e1e6b2" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-a318dcb e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="a318dcb" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-f8456b7 elementor-invisible elementor-widget elementor-widget-image-carousel" data-id="f8456b7" data-element_type="widget" data-e-type="widget" data-settings='{"slides_to_show":"1","navigation":"none","autoplay_speed":2000,"_animation":"fadeInUp","autoplay":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","infinite":"yes","effect":"slide","speed":500}' data-widget_type="image-carousel.default">
														<div className="elementor-widget-container">
															<div className="elementor-image-carousel-wrapper swiper" role="region" aria-roledescription="carousel" aria-label="Image Carousel" dir="ltr">
																<div className="elementor-image-carousel swiper-wrapper swiper-image-stretch" aria-live="off">
																	<div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="1 of 3"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/01/WEDDING-EVENTS.jpg" alt="Wedding catering services in Pune" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="2 of 3"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/03/CNC05371-scaled.jpg" alt="CNC05371" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="3 of 3"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/03/CNC05411-scaled.jpg" alt="CNC05411" /></figure></div>			</div>

															</div>
														</div>
													</div>
													<div className="elementor-element elementor-element-e1259df elementor-invisible elementor-widget elementor-widget-elementskit-heading" data-id="e1259df" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">About Us</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div>				<div className="ekit-heading__description">
																<p><span style={{ fontWeight: '400' }}>The pandemic was a challenging time, with widespread job losses and uncertainty affecting countless lives. Amidst this, Pratik?s passion for the culinary arts and Bhavika?s unwavering confidence in her partner sparked the creation of TSR Catering &amp; Events, driven by the belief that <em>?whatever happens, happens for good!"</em></span></p>
																<p><span style={{ fontWeight: '400' }}>Our commitment to health and quality is unwavering. Every dish is prepared with refined oil or pure ghee, fresh ingredients, and no harmful additives like Ajinomoto, artificial colors, or Dalda.</span></p>
															</div>
															</div></div>				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-14d7574 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="14d7574" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-bab7080 elementor-invisible elementor-widget elementor-widget-elementskit-heading" data-id="bab7080" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">OUR JOURNEY</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div>				<div className="ekit-heading__description">
															<p><span style={{ fontWeight: '400' }}>Founded in 2020 in Baner, Pune, TSR Catering &amp; Events began as a small cloud kitchen by Bhavika Tailor, a finance professional, and Pratik Tailor, an engineer-turned-MBA-turned-foodpreneur. Initially launched as "Qwik O?Byts" to provide restaurant-quality meals made with homely ingredients, the business quickly expanded into catering and event management. </span></p>
														</div>
														</div></div>				</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-cint-about e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-widget elementor-widget-elementskit-heading" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Using our C.I.N.T. methodology, we&apos;ve built a strong reputation ? reflected in our Google ratings and repeat clients across Pune.</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-afcf3b6 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="afcf3b6" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-dc06630 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no elementor-invisible e-con e-child" data-id="dc06630" data-element_type="container" data-e-type="container" data-settings='{"animation":"zoomInUp"}'>
													<div className="elementor-element elementor-element-7eceb63 elementor-widget elementor-widget-ucaddon_vertical_curve_timeline" data-id="7eceb63" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_vertical_curve_timeline.default">
														<div className="elementor-widget-container">
<div className="ue-container" id="uc_vertical_curve_timeline_elementor_7eceb63">
																<div className="ue-timeline">
																	<div className="ue-outer">

																		<div className="ue-card elementor-repeater-item-3c0a8ce">

																			<div className="ue-slno">
																				1
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2019</h4>      	        <div className="ue-description"><p>Started with a small 180 sq. ft. caf�.</p></div>      	      		      	    </div>
																		</div>
																		<div className="ue-card elementor-repeater-item-ada3678">

																			<div className="ue-slno">
																				2
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2020</h4>      	        <div className="ue-description"><p>Expanded into catering; first outdoor catering (ODC) order worth ?8,100</p></div>      	      		      	    </div>
																		</div>
																		<div className="ue-card elementor-repeater-item-2e90797">

																			<div className="ue-slno">
																				3
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2022</h4>      	        <div className="ue-description"><p>Entered corporate canteens with daily meal plans. Began managing corporate hospitality and coworking space events. First end-to-end wedding catering order.</p></div>      	      		      	    </div>
																		</div>
																		<div className="ue-card elementor-repeater-item-7953f1f">

																			<div className="ue-slno">
																				4
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2023</h4>      	        <div className="ue-description"><p>Full event planning for private &amp; corporate parties. Launched a venture of tsr catering &amp; events -- "Party Meals by Kilo" pilot, winning hearts.</p></div>      	      		      	    </div>
																		</div>
																		<div className="ue-card elementor-repeater-item-1aa8cf5">

																			<div className="ue-slno">
																				5
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2024</h4>      	        <div className="ue-description"><p>Expanded daily meal plans and corporate lunches.</p></div>      	      		      	    </div>
																		</div>
																		<div className="ue-card elementor-repeater-item-bfa0ef4">

																			<div className="ue-slno">
																				6
																			</div>
																			<div className="ue-info">


																				<h4 className="ue-title">2025</h4>      	        <div className="ue-description"><p>Officially launched "Party Meals by Kilo" website. Shifted to a 1,500 sq. ft. kitchen with a capacity for 5,000 guests.</p></div>      	      		      	    </div>
																		</div>


																	</div>
																</div>
															</div>
															{/* end Vertical Curved Timeline */}				</div>
													</div>
												</div>
												<div className="elementor-element elementor-element-ca616f5 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ca616f5" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-6323e0b elementor-invisible elementor-widget elementor-widget-image-carousel" data-id="6323e0b" data-element_type="widget" data-e-type="widget" data-settings='{"slides_to_show":"1","navigation":"none","autoplay_speed":2000,"_animation":"fadeInUp","autoplay":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","infinite":"yes","effect":"slide","speed":500}' data-widget_type="image-carousel.default">
														<div className="elementor-widget-container">
															<div className="elementor-image-carousel-wrapper swiper" role="region" aria-roledescription="carousel" aria-label="Image Carousel" dir="ltr">
																<div className="elementor-image-carousel swiper-wrapper swiper-image-stretch" aria-live="off">
																	<div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="1 of 5"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/uploads/elementor/thumbs/pexels-photo-2530586-2530586-scaled-r3bs94c9m3ckn9bu99ixknwx76q5hnerbixe1i4u2o.jpg" alt="Cozy caf� interior featuring leather chairs, framed wall art, and pendant lighting. Ideal htmlFor meetings." /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="2 of 5"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/uploads/elementor/thumbs/ANI07906-1-scaled-r2hwhvnxasobyat2579atcjv90d8wqy45h9mjnef5s.jpg" alt="ANI07906" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="3 of 5"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/uploads/elementor/thumbs/ANI07689-scaled-r2hwfucihpvysprk1bkeev1wwyem8cv1vedr42f4n4.jpg" alt="ANI07689" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="4 of 5"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/uploads/elementor/thumbs/ANI07677-1-scaled-r2hweumna0j2jj7ftw4ks42ecbao3ux92hlavjw37k.jpg" alt="ANI07677" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="5 of 5"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/uploads/elementor/thumbs/ANI07906-scaled-r2hvwgw9mnd7i1wn5y380r1w51w9kxy7vibh0r58w0.jpg" alt="ANI07906" /></figure></div>			</div>

															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-bbdfa23 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="bbdfa23" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-2e566d7 wpr-testimonial-slider-columns-1 wpr-testimonial-slider-columns--mobile1 wpr-testimonial-slider-columns--tablet1 wpr-testimonial-triangle-yes wpr-testimonial-meta-position-bottom wpr-testimonial-meta-align-center wpr-testimonial-image-position-center elementor-widget elementor-widget-wpr-testimonial" data-id="2e566d7" data-element_type="widget" data-e-type="widget" data-settings='{"testimonial_amount":"1","testimonial_amount_mobile":"1","testimonial_amount_tablet":1,"testimonial_slides_to_scroll":1,"testimonial_loop":"yes"}' data-widget_type="wpr-testimonial.default">
												<div className="elementor-widget-container">
													<div className="wpr-testimonial-carousel-wrap">

														<div className="wpr-testimonial-carousel" dir="ltr" data-slick='{"rtl":false,"infinite":true,"speed":700,"arrows":true,"dots":true,"autoplay":false,"autoplaySpeed":1000,"pauseOnHover":"","prevArrow":"#wpr-testimonial-prev-2e566d7","nextArrow":"#wpr-testimonial-next-2e566d7","sliderSlidesToScroll":1}' data-slide-effect="slide">



															<div className="wpr-testimonial-item elementor-repeater-item-5faf5d4 elementor-clearfix">

																<div className="wpr-testimonial-meta elementor-clearfix">
																	<div className="wpr-testimonial-meta-inner">

																		<div className="wpr-testimonial-image">
																			<img decoding="async" src="/assets/images/10/Pratik-Tailor.jpg" alt="Pratik Tailor" />
																		</div>


																		<div className="wpr-testimonial-meta-content-wrap">
																			<div className="wpr-testimonial-name">Pratik Tailor</div>



																		</div>
																	</div>
																</div>


																<div className="wpr-testimonial-content-wrap">
																	<div className="wpr-testimonial-content-inner">





																	</div>
																</div>



															</div>


															<div className="wpr-testimonial-item elementor-repeater-item-24d2ff1 elementor-clearfix">

																<div className="wpr-testimonial-meta elementor-clearfix">
																	<div className="wpr-testimonial-meta-inner">

																		<div className="wpr-testimonial-image">
																			<img decoding="async" src="/assets/images/10/Bhavika-Tailor.jpg" alt="Bhavika Tailor" />
																		</div>


																		<div className="wpr-testimonial-meta-content-wrap">
																			<div className="wpr-testimonial-name">Bhavika Tailor</div>



																		</div>
																	</div>
																</div>


																<div className="wpr-testimonial-content-wrap">
																	<div className="wpr-testimonial-content-inner">





																	</div>
																</div>



															</div>
														</div>

														<div className="wpr-testimonial-controls">
															<div className="wpr-testimonial-dots"></div>
														</div>

														<div className="wpr-testimonial-arrow-container">
															<div className="wpr-testimonial-prev-arrow wpr-testimonial-arrow" id="wpr-testimonial-prev-2e566d7">
																<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 283.4 512" style={{ enableBackground: 'new 0 0 283.4 512' }} xmlSpace="preserve"><g><polygon className="st0" points="54.5,256.3 283.4,485.1 256.1,512.5 0,256.3 0,256.3 27.2,229 256.1,0 283.4,27.4 "></polygon></g></svg>				</div>
															<div className="wpr-testimonial-next-arrow wpr-testimonial-arrow" id="wpr-testimonial-next-2e566d7">
																<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 283.4 512" style={{ enableBackground: 'new 0 0 283.4 512' }} xmlSpace="preserve"><g><polygon className="st0" points="54.5,256.3 283.4,485.1 256.1,512.5 0,256.3 0,256.3 27.2,229 256.1,0 283.4,27.4 "></polygon></g></svg>				</div>
														</div>
													</div>

												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-064ba23 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="064ba23" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-2f5f6af e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="2f5f6af" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-b1d62c4 elementor-invisible elementor-widget elementor-widget-elementskit-heading" data-id="b1d62c4" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInDown"}' data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Let?s Plan Your Next Event!</h2>				<div className="ekit-heading__description">
																<p><span style={{ fontWeight: '400' }}>We?re here to bring your vision to life, whether it?s an intimate gathering or a grand celebration. Get in touch with us today and let?s make your event extraordinary!</span></p>
															</div>
															</div></div>				</div>
													</div>
													<div className="elementor-element elementor-element-1b538bf elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-invisible elementor-widget elementor-widget-icon-list" data-id="1b538bf" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInDown"}' data-widget_type="icon-list.default">
														<div className="elementor-widget-container">
															<ul className="elementor-icon-list-items">
																<li className="elementor-icon-list-item">
																	<span className="elementor-icon-list-icon">
																		<i aria-hidden="true" className="icon icon-phone-handset"></i>						</span>
																	<span className="elementor-icon-list-text"> Phone: 7249464781</span>
																</li>
																<li className="elementor-icon-list-item">
																	<span className="elementor-icon-list-icon">
																		<i aria-hidden="true" className="icon icon-email1"></i>						</span>
																	<span className="elementor-icon-list-text">Gmail: alpphafoods@gmail.com</span>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div className="elementor-element elementor-element-147fbeb e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="147fbeb" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-15560b0 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="15560b0" data-element_type="container" data-e-type="container">
														<div className="elementor-element elementor-element-b641335 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="b641335" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
															<div className="elementor-element elementor-element-7ae5536 elementor-position-inline-start elementor-view-default elementor-mobile-position-block-start elementor-invisible elementor-widget elementor-widget-icon-box" data-id="7ae5536" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInRight"}' data-widget_type="icon-box.default">
																<div className="elementor-widget-container">
																	<div className="elementor-icon-box-wrapper">

																		<div className="elementor-icon-box-icon">
																			<span className="elementor-icon">
																				<i aria-hidden="true" className="icon icon-dart-board"></i>				</span>
																		</div>

																		<div className="elementor-icon-box-content">

																			<h3 className="elementor-icon-box-title">
																				<span>
																					Our Mission						</span>
																			</h3>

																			<p className="elementor-icon-box-description">
																				To deliver bespoke, high-quality catering and event services that exceed client expectations, creating memorable experiences for every guest					</p>

																		</div>

																	</div>
																</div>
															</div>
														</div>
														<div className="elementor-element elementor-element-26d25b5 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="26d25b5" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
															<div className="elementor-element elementor-element-6b19500 elementor-position-inline-start elementor-view-default elementor-mobile-position-block-start elementor-invisible elementor-widget elementor-widget-icon-box" data-id="6b19500" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInRight"}' data-widget_type="icon-box.default">
																<div className="elementor-widget-container">
																	<div className="elementor-icon-box-wrapper">

																		<div className="elementor-icon-box-icon">
																			<span className="elementor-icon">
																				<i aria-hidden="true" className="icon icon-eye2"></i>				</span>
																		</div>

																		<div className="elementor-icon-box-content">

																			<h3 className="elementor-icon-box-title">
																				<span>
																					Our Vision						</span>
																			</h3>

																			<p className="elementor-icon-box-description">
																				To be recognized as one of Pune?s top three premium catering and event management providers by 2027, celebrated for exceptional culinary experiences and flawless event execution					</p>

																		</div>

																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>



								</div>{/* .entry-content</div> */}
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default About

